module.exports = __webpack_public_path__ + "static/media/depthsquasher.ef6994b1.frag";